import { render, staticRenderFns } from "./PlacementGoal.vue?vue&type=template&id=1f34fa1c"
import script from "./PlacementGoal.vue?vue&type=script&lang=js"
export * from "./PlacementGoal.vue?vue&type=script&lang=js"
import style0 from "./PlacementGoal.vue?vue&type=style&index=0&id=1f34fa1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports